import axios from "axios"
import { isString } from "lodash"

const imagesRemotePath = "/logos"

const mapRemoteImages = {
  "PPL INDIA": "ppl_india.png",
  "ASIRINDO": "asirindo.png",
  "MLC": "mlc.png",
  "PNR": "pnr.png",
  "MRSS": "mrss.png",
  "BMAT": "bmat.jpeg",
  "BMAT DEMO": "bmat.jpeg",
  "SOUNDSYS": "soundsys.png",
  "SGP": "sgp.svg",
  "AGINPRO": "aginpro.png",
  "HKRIA": "hkria_logo.png",
  "ASAP, E.G.C.": "asap_egc.jpeg",
  "PRODUCE": "produce.jpg",
  "FONOTICA": "fonotica.jpeg",
  "EMRA": "emra.jpg",
  "EVOLUTION": "evolution.png",
  "PRM": "prm.png",
  "SOMEXFON": "somexfon.png",
}

let tokenRegistry = {}

function remoteImg (imgName) {
  const imageRemoteName = mapRemoteImages[imgName]

  return (
    imageRemoteName
      ? `${imagesRemotePath}/${imageRemoteName}`
      : ""
  )
}

function responsePaginatedAdapter (resp) {
  return  {
    data: resp.data.results,
    count: resp.data.count || resp.data.results.length || 0
  }
}

function doRequest (url, query, toast= null) {
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  if (url in tokenRegistry) {
    tokenRegistry[url].cancel("by next request to " + url)
  }
  const promise = axios
    .get(url, {
      params: query,
      cancelToken: source.token
    })
    .catch(function (thrown) {
      if (axios.isCancel(thrown)) {
        window.console.log("info", "Request canceled ", thrown.message)
      } else {
        if (toast)
          toast(thrown.response.data[0])
        window.console.log("error", thrown)
      }
    })
  tokenRegistry[url] = source
  return promise
}

function isDefined (obj) {
  return obj !== null && obj !== undefined
}

function isDefinedString (string) {
  return string !== "" && isDefined(string)
}

function safeUpdateArray (arr, element) {
  var index = arr.indexOf(element)
  /* needed to avoid vue mutation error */
  let newArray = arr.slice()

  if (index > -1) {
    newArray.splice(index, 1)
  } else {
    newArray.push(element)
  }

  return newArray
}

function serialize (obj) {
  var str = []
  for (var p in obj) {
    if (Object.prototype.hasOwnProperty.apply(obj, [p])) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
    }
  }
  return str.join("&")
}

function validateEmail (email) {
  /* eslint-disable */
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

function getHost() {
  let protocol = location.protocol
  let slashes = protocol.concat("//")
  let host = slashes.concat(window.location.host)
  return host
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

function capitalize(string) {
  if (!isString(string)) return ""

  return string
    .split(" ")
    .map(function(chunk) {
      return capitalizeFirstLetter(chunk)
    })
    .join(" ")
}

function removeEl(arr, el) {
  let index = arr.indexOf(el)
  if (index > -1) {
    arr.splice(index, 1)
  }
}

export {
  responsePaginatedAdapter,
  doRequest,
  isDefinedString,
  safeUpdateArray,
  isDefined,
  serialize,
  validateEmail,
  remoteImg,
  removeEl,
  capitalize,
  capitalizeFirstLetter,
}
